"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
exports.StyledToggle = styled_components_1.default.div `
  position: relative;
  z-index: 1;
  flex: 1 1 auto;
  min-height: 30px;
`;
exports.StyledToggleBody = styled_components_1.default.div `
  display: flex;
  color: ${props => props.theme.colors.color};
  box-sizing: border-box;
  width: 100%;
  padding: 5px 15px 5px 20px;
  box-sizing: border-box;
  background: ${props => props.theme.colors.background};
`;
//# sourceMappingURL=info-pane-toggle.styles.js.map